export const WorkScheduleConstant = {
	GET_MY_SUCCESS: 'WS_GET_MY_SUCCESS',
	GET_MY_FAIL: 'WS_GET_MY_FAIL',
	SAVE_BASE_SUCCESS: 'WS_SAVE_BASE_SUCCESS',
	RESET_BASE_SUCCESS: 'WS_RESET_BASE_SUCCESS',
	ADD_OVERRIDE_RANGE_SUCCESS: 'WS_ADD_OVERRIDE_RANGE_SUCCESS',
	DELETE_OVERRIDE_SUCCESS: 'WS_DELETE_OVERRIDE_SUCCESS',
	SET_YEAR_MONTH: 'WS_SET_YEAR_MONTH',
	LOADING: 'WS_LOADING',
	LOADED: 'WS_LOADED',
};
